export default "__VITE_ASSET__601261b7__"